import { chunk, isArray, isEmpty, map, size } from 'lodash/fp';

import { Tile } from '../../components/content-tiles-section/types';
import { TILE_VARIANTS } from '../../ahm-constants/ui';

const sortTiles = (tiles: Tile[] | null | undefined, tileVariant: string) => {
  if (isEmpty(tiles) || !isArray(tiles)) {
    return [];
  }

  const rows = chunk(2, tiles);

  return map(
    (row: Tile[]) =>
      map((tile: Tile) => {
        if (size(row) === 1) {
          return { ...tile, variant: TILE_VARIANTS.FULL_WIDTH };
        }
        return { ...tile, variant: tileVariant };
      }, row),
    rows,
  );
};

export default sortTiles;
